import { Fragment, useMemo } from 'react';
import styled from 'styled-components';

import { getFlatDescription } from '../../common/helpers/flat.utils';
import { IFlat } from '../../common/model/flat.model';
import useI18n from '../../common/hooks/useI18n';

import Summary from './summary';

type Props = {
  flat: IFlat;
  title: string;
};

const Title = styled.h1`
  ${(props) => props.theme.font.h2}
`;

const Divider = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #e0e0e0;
`;

const SummarySection = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

const Info = styled.div`
  font-size: 14px;
  line-height: 21px;
  white-space: pre-wrap;
  overflow-x: hidden;
`;

const Description: React.FC<Props> = ({ flat, title }) => {
  const i18n = useI18n();

  const description = useMemo(
    () => getFlatDescription(flat, i18n.activeLocale),
    [flat, i18n.activeLocale]
  );

  return (
    <Fragment>
      <Title>{title}</Title>
      <Divider />

      <SummarySection>
        <Summary flat={flat} />
      </SummarySection>

      <Info
        key={description.substring(0, 10) + new Date().getTime()}
        as="div"
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </Fragment>
  );
};

export default Description;
